import filterBySchedulesLevel from './filterBySchedulesLevel'
import filterBySchedulesPeriod from './filterBySchedulesPeriod'

export default (searchedBy, filters, agenda, level) => {
  filters['schedules'] = {
    level: agenda.level_id
  }

  filterBySchedulesLevel(searchedBy, filters, agenda, level)
  filterBySchedulesPeriod(searchedBy, filters, agenda, level)
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/filters/filterBySchedules.js